import { createSelector } from 'reselect';
import DocumentMetadataRecord from '../records/DocumentMetadataRecord';
const getDocumentsSummary = state => {
  var _state$documentsSumma;
  return (_state$documentsSumma = state.documentsSummary) === null || _state$documentsSumma === void 0 ? void 0 : _state$documentsSumma.documentsSummary;
};
export const makeGetDocumentMetadata = () => createSelector([getDocumentsSummary, (_state, deckId) => deckId], (documentsSummary, deckId) => {
  const documentSummary = documentsSummary === null || documentsSummary === void 0 ? void 0 : documentsSummary.get(deckId);
  return (documentSummary === null || documentSummary === void 0 ? void 0 : documentSummary.metadata) || new DocumentMetadataRecord();
});